import { createReducer } from '@reduxjs/toolkit'

import { Menu } from '@/model/menu'
import { axios } from '@/utils/axios'

import { createAppAsyncThunk } from './utils'

const namespace = 'menu'

export const readAllMenus = createAppAsyncThunk(
  `${namespace}/readAllMenus`,
  async () => (await axios.get<Menu[]>(
    '/menu/bar/all',
  )).data,
)

const initialState: {
  menus: Menu[]
} = {
  menus: [],
}

const reducer = createReducer(initialState, (builder) => {
  builder.addCase(readAllMenus.fulfilled, (draft, { payload }) => {
    draft.menus = payload
  })
})

export default { [namespace]: reducer }
